import { useNavigate, useLocation } from "react-router-dom";
import { AppBar, Toolbar, Box, Typography, IconButton } from "@mui/material";
import api, { adminVersion } from "../../../Services/api";
import MenuIcon from "@mui/icons-material/Menu";
import hcpLogo from "../../../Assets/branding/hcp-logo";
import { useAuth } from "../../../Hooks/Auth";
import { AccountMenu } from "../../AccountMenu/account-menu.component";
import { NotificationMenu } from "../../NotificationMenu/notification-menu.component";
import { ListNotificationsUseCase } from "../../../Usecase/Notifications/list-notifications-usecase";
import { NotificationsApiRemoteService } from "../../../Services/api/notifications/notifications-service";
import { MarkAsReadNotificationsUseCase } from "../../../Usecase/Notifications/mark-as-read-notifications-usecase";

export default function HCPHeader({ onMenuClick }: { onMenuClick: () => void }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  
  const listNotificationsUseCase = new ListNotificationsUseCase(new NotificationsApiRemoteService(api));
  const markAsReadNotificationUseCase = new MarkAsReadNotificationsUseCase(new NotificationsApiRemoteService(api));

  return (
    <AppBar position="static" sx={{ backgroundColor: '#FFF', boxShadow: 'none', borderBottom: '1px solid #e0e0e0', minHeight: '73px', display: 'flex', justifyContent: 'center' }}>
      <Toolbar>
        <IconButton onClick={onMenuClick} size="large" edge="start" color="primary" aria-label="menu" sx={{ mr: 2 }}>
          <MenuIcon />
        </IconButton>
        
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            component="button"
            type="button"
            onClick={() => navigate('/hcp/dashboard')}
            aria-label="Ir para o início do HCP"
            sx={{
              border: 0,
              p: 0,
              m: 0,
              background: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box
              component="img"
              src={hcpLogo}
              alt="Papello HCP"
              sx={{ width: { xs: 140, sm: 160 }, height: 'auto', display: 'block', mr: 2 }}
            />
          </Box>
          <Typography variant="subtitle1" color="text.secondary" fontWeight="600" sx={{ display: { xs: 'none', sm: 'block' }, borderLeft: '1px solid #ddd', paddingLeft: 2, marginLeft: 1 }}>
            Central de Produção
          </Typography>
        </Box>
        
        <Box sx={{ flexGrow: 1 }} />
        
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography fontSize={12} fontWeight={600} color="text.secondary" sx={{ mr: 2, display: { xs: 'none', sm: 'block' } }}>
            Versão: {adminVersion}
          </Typography>
          
          <NotificationMenu listNotificationsUseCase={listNotificationsUseCase} markAsReadNotificationUseCase={markAsReadNotificationUseCase} />
          <AccountMenu />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

